import app from '@/app';
import templateUrl from './unit-price-tables-detail.html';

/* @ngInject */
function Controller($controller, UnitPriceTable, Principal, $http, $translate, DialogService) {
  const $ctrl = this;

  $controller('AbstractEntityDetailController', {
    $ctrl,
    resource: UnitPriceTable,
    type: 'unitPriceTables'
  });

  var originalSave = $ctrl.save;

  Principal.identity().then(account => {
    $ctrl.currentAccount = account;
  });

  // load units for materialsServices unit select
  $http.get('api/materialsServices/units').then(function(response) {
    $ctrl.allUnits = response.data || [];
  });

  var transition = $ctrl.transition;
  $ctrl.transition = function(params) {
    transition(params);
    if (params.id === 'new') {
      $ctrl.entity = { id: $ctrl.idgen--, name: '', materialsServices: [] };
    }
  };

  $ctrl.hasDuplicate = function(name, currentIndex) {
    if (!name) return false;
    if (!$ctrl.entity || !$ctrl.entity.materialsServices) return false;
    let nameLower = name.trim().toLowerCase();
    for (let i = 0; i < $ctrl.entity.materialsServices.length; i++) {
      let currentName = $ctrl.entity.materialsServices[i].name;
      if (i !== currentIndex && currentName && currentName.trim().toLowerCase() === nameLower) {
        return true;
      }
    }
    return false;
  };

  $ctrl.hasAnyDuplicate = function() {
    if (!$ctrl.entity || !$ctrl.entity.materialsServices) return false;
    let names = new Set();
    for (let i = 0; i < $ctrl.entity.materialsServices.length; i++) {
      let name = $ctrl.entity.materialsServices[i].name;
      if (name) {
        let nameLower = name.trim().toLowerCase();
        if (names.has(nameLower)) {
          return true;
        }
        names.add(nameLower);
      }
    }
    return false;
  };

  $ctrl.addNewMaterialService = function() {
    if ($ctrl.hasAnyDuplicate()) return;
    if (!$ctrl.entity.materialsServices) $ctrl.entity.materialsServices = [];
    $ctrl.entity.materialsServices.push({ id: null, name: '', unit: null, value: 0 });
    if ($ctrl.unitPriceTablesForm) {
      $ctrl.unitPriceTablesForm.$setDirty();
    }
  };

  $ctrl.removeMaterialService = function(index) {
    if ($ctrl.entity && $ctrl.entity.materialsServices) {
      $ctrl.entity.materialsServices.splice(index, 1);
      if ($ctrl.unitPriceTablesForm) {
        $ctrl.unitPriceTablesForm.$setDirty();
      }
    }
  };

  $ctrl.save = function() {
    if (!$ctrl.entity || !$ctrl.entity.id || $ctrl.entity.id < 0) {
      originalSave();
      return;
    }

    $http.get('api/unit-price-tables/' + $ctrl.entity.id + '/linked-cost-tables')
      .then(function(response) {
        var linkedCostTables = response.data || [];
        if (linkedCostTables.length === 0) {
          originalSave();
          return;
        }

        var names = linkedCostTables.map(function(ct) { return ct.name; }).join(', ');
        var message = $translate.instant('unitPriceTable.linkedCostTables.confirm', { names: names });

        DialogService.confirm(
          '',
          message,
          null,
          null,
          'btn-warning',
          'fa-exclamation-triangle',
          'action.accept',
          function() {
            // originalSave() already shows the success toast and navigates back.
            // Return a no-op thenable so DialogService.confirm does not fire a second
            // AlertService.success (which caused the duplicated save message).
            originalSave();
            return { then: function() {} };
          }
        );
      }, function() {
        originalSave();
      });
  };
}

const component = {
  templateUrl,
  controller: Controller,
  require: {
    parent: '^unitPriceTablesSearch'
  },
  bindings: {
    $transition$: '<',
    entity: '<'
  }
};

app.component('unitPriceTablesDetail', component);
